import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SortableList } from "@/components/SortableList";

export function GroupBySelect({ label, value, options, onChange, testid }) {
  return (
    <div className="space-y-1">
      <div className="lf-label">{label}</div>
      <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
        <SelectTrigger className="w-60" data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No grouping (A–Z)</SelectItem>
          {options.map((o) => <SelectItem key={o.key} value={o.key}>{o.label} · {o.count}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

const paths = (groups) => groups.flatMap((g) => [g.path, ...g.children.map((c) => c.path)]);
const ids = (groups) => groups.flatMap((g) => [...g.entries, ...g.children.flatMap((c) => c.entries)].map((e) => e.id));

function Entries({ node, scope, onReorder }) {
  if (!node.entries.length) return null;
  return (
    <SortableList scope={scope} items={node.entries} getKey={(e) => e.id} onReorder={onReorder} className="space-y-0.5 pl-1" render={(e) => (
      <div className="py-0.5 text-sm text-[#E8DFD1]" data-testid={`export-entry-${e.id}`}>{e.name}</div>
    )} />
  );
}

export function GroupTree({ sec, onChange }) {
  const commit = (groups) => {
    const s = { ...sec, groups };
    onChange(s, { group_order: paths(groups), entry_order: ids(groups) });
  };
  const setNode = (gi, ci, patch) => commit(sec.groups.map((g, i) => (i !== gi ? g : ci == null ? { ...g, ...patch } : { ...g, children: g.children.map((c, j) => (j === ci ? { ...c, ...patch } : c)) })));
  if (!sec.groups.length) return <p className="text-sm text-[#A8A090]">No entries in this category.</p>;
  if (sec.groups.length === 1 && !sec.groups[0].name) {
    return <Entries node={sec.groups[0]} scope={`e:${sec.category}`} onReorder={(entries) => setNode(0, null, { entries })} />;
  }
  return (
    <SortableList scope={`g:${sec.category}`} items={sec.groups} getKey={(g) => g.path} onReorder={commit} className="space-y-2" testid="export-group-tree" render={(g, gi) => (
      <div className="rounded-md border border-[#2D3442] bg-[#13171F] px-3 py-2" data-testid={`export-group-${g.path}`}>
        <div className="mb-1 text-xs font-semibold uppercase tracking-[0.12em] text-[#F59E0B]">{g.name} <span className="font-normal text-[#A8A090]">· {g.entries.length + g.children.reduce((n, c) => n + c.entries.length, 0)}</span></div>
        <Entries node={g} scope={`e:${g.path}`} onReorder={(entries) => setNode(gi, null, { entries })} />
        {g.children.length > 0 && (
          <SortableList scope={`c:${g.path}`} items={g.children} getKey={(c) => c.path} onReorder={(children) => setNode(gi, null, { children })} className="mt-1 space-y-1.5 border-l border-[#2D3442] pl-2" render={(c, ci) => (
            <div data-testid={`export-group-${c.path}`}>
              <div className="text-xs font-medium text-[#A8A090]">{c.name} · {c.entries.length}</div>
              <Entries node={c} scope={`e:${c.path}`} onReorder={(entries) => setNode(gi, ci, { entries })} />
            </div>
          )} />
        )}
      </div>
    )} />
  );
}
